import { css } from '@emotion/react';
import { Props } from './index';
import ArticleOrder from './components/organisms/ArticleOrder';

const CardApp: React.FC<Props> = (props) => {
  const { talknAPI, state, root, maxItems, showEmpty } = props;
  return (
    <div css={styles.container}>
      <ArticleOrder talknAPI={talknAPI} state={state} root={root} maxItems={maxItems} showEmpty={showEmpty} />
    </div>
  );
};

export default CardApp;

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  `,
};
